module.exports = __webpack_public_path__ + "static/media/logo.d78eddc3.png";